export const UPDATE_DRIVER_LIST = "UPDATE_DRIVER_LIST";

export function updateDriverList(data){
    return { type: UPDATE_DRIVER_LIST, payload: data};
}
